// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SoSl","tabsBox":"styles_tabsBox__aTqmM","createButton":"styles_createButton__3G_MM"};